import * as actions from "../actions/chatActions";
import format from "date-fns/format";

const initialState = {
  messages: []
};

export default function chat(state = initialState, action) {
  switch (action.type) {
    case actions.APPEND_MESSAGE: {
      return {
        ...state,
        messages: state.messages.concat({ ...action.message, addedAt: action.message.addedAt || format(new Date(), "HH:mm") })
      };
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./app/reducers/chat.js